import React from 'react';
import { Modal, Typography } from 'antd';
import { Button } from '@gamesb42/ui-kit';

const { Title, Text } = Typography;

interface EmailSentModalProps {
  visible: boolean;
  email: string;
  onClose: () => void;
}

const EmailSentModal: React.FC<EmailSentModalProps> = ({ visible, email, onClose }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={680}
      centered
      closable={false}
      okButtonProps={{ style: { display: 'none' } }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '20px',
          gap: '20px',
        }}
      >
        {/* Email Icon */}
        <div
          style={{
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            backgroundColor: '#7145EC',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="60" cy="60" r="56" fill="#825BF2" />
            <path d="M30 55L60.5 71L91 55" stroke="#FBFBFD" stroke-width="3" stroke-linecap="round" />
            <path
              d="M69.12 37C56.5447 37 40.3773 37 32.9958 37C30.7867 37 29 38.7909 29 41V83C29 85.2091 30.7909 87 33 87H87C89.2091 87 91 85.2091 91 83V55.5"
              stroke="#FBFBFD"
              stroke-width="3"
              stroke-linecap="round"
            />
            <path d="M78 40.8462L84.5709 47L95 37" stroke="#FBFBFD" stroke-width="3" stroke-linecap="round" />
          </svg>
        </div>

        {/* Title */}
        <Title
          level={3}
          style={{
            marginBottom: 0,
            textAlign: 'center',
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: '40px',
            color: '#090909',
          }}
        >
          We sent an email to <span style={{ color: '#825BF2' }}>{email}</span>
        </Title>

        {/* Description */}
        <Text
          style={{
            color: '#4E5169',
            fontSize: '16px',
            lineHeight: '20px',
            textAlign: 'center',
          }}
        >
          You will receive an email with further instructions
        </Text>
      </div>

      {/* Footer with button */}
      <div
        style={{
          padding: '20px',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          size="large"
          onClick={onClose}
          style={{
            backgroundColor: '#F7F7FB',
            color: '#686F88',
            padding: '10px 20px 8px',
            width: '132px',
            height: '60px',
            fontWeight: 500,
          }}
        >
          Got it
        </Button>
      </div>
    </Modal>
  );
};

export default EmailSentModal;
